export const globalLoading = (msg) => {
  let event = new Event("GLOBAL_LOADING");

  window.GLOBAL_LOADING = {
    loading: true,
    msg: msg,
  };

  window.dispatchEvent(event);
};

export const closeGlobalLoading = () => {
  let event = new Event("GLOBAL_LOADING");

  window.GLOBAL_LOADING = {
    loading: false,
    msg: "",
  };

  window.dispatchEvent(event);
};
